<section id="wallet-action-buttons">
  <div class="actionbutton__wrapper">
    @if ({ checkoutFlowEnabled: checkoutFlowEnabled$ | async }; as context) {
      @for (button of actionButtons; track button) {
        <button
          (click)="button.action(context.checkoutFlowEnabled)"
          [disabled]="(button.disabled$ | async) === true"
          class="btn actionbutton">
          <span
            class="actionbutton__inner"
            position="top"
						[bp-tooltip]="
							button.tooltipKey$
								| async
								| translate
									: [
											minWithdrawFiatAmount()
												| fiat_precision_symbol
													: {
															id: fiat?.getId(),
															currencies: [fiat]
													  }
									  ]
						">
          <span class="actionbutton__icon">
            <span [className]="button.icon" class="actionbutton__icon__actual symbol-icon"></span>
          </span>
          <span class="actionbutton__label">
            {{ button.labelKey | translate: [fiat.getSymbol()] }}
          </span>
        </span>
      </button>
    }
  }
</div>
</section>
